(function () {
    const videoToggles = document.querySelectorAll('.play-pause-btn,.mute-btn');
    let isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (videoToggles) {
        videoToggles.forEach(videoToggle => {
            const isPlayPause = videoToggle.classList.contains('play-pause-btn');
            let parentElement = videoToggle.parentElement;
            if (isPlayPause) {
                parentElement = parentElement.parentElement;
            }
            const isYT = parentElement.querySelector('iframe');
            const video = parentElement.querySelector('video') || isYT;      
            let muted = true;
            let playing = true;
            const videoMethod = (type) => {
                const method = isYT.classList.contains('js-vimeo') ? 
                    `{"method":"${type}"}` : 
                    `{"event":"command","func":"${type}","args":""}`;
                video.contentWindow.postMessage(method, '*');
            };
            if (!!video) {
                if (isPlayPause) {
                    parentElement.addEventListener('click', function(e){
                        e.preventDefault();
                        if (e.target.classList.contains('play-pause-container')){
                            videoToggle.click();
                        }
                    });
                }
                videoToggle.addEventListener('click', function(e){
                    e.preventDefault();
                    if (isPlayPause) { //play/pause click
                        playing = !playing;
                        if (playing) {
                            if (!!isYT) {
                                videoMethod('playVideo');
                            }
                            else {
                                video.play();
                            }
                            video.classList.add('keep-playing');
                            video.parentElement.classList.add('playing');
                            videoToggle.setAttribute("aria-label", "pause video");
                            videoToggle.classList.add('active');
                        }
                        else {
                            if (!!isYT) {
                                videoMethod('pauseVideo');
                            }
                            else {
                                video.pause();
                            }
                            video.classList.remove('keep-playing');
                            video.parentElement.classList.remove('playing');
                            videoToggle.setAttribute("aria-label", "play video");
                            videoToggle.classList.remove('active');
                        }
                    }
                    else { //mute click
                        muted = !muted;
                        if (!!isYT) {
                            videoMethod(muted ? 'mute' : 'unMute');
                        }
                        else {
                            video.muted = muted;
                        }
                        videoToggle.setAttribute("aria-label", muted ? "unmute video" : "mute video");
                        if (muted) {
                            video.setAttribute("muted", "muted");
                            videoToggle.classList.add('muted');
                        }
                        else {
                            video.removeAttribute("muted");
                            videoToggle.classList.remove('muted');
                        }
                    }
                });
                if (isPlayPause) {
                    if (!!isYT && isMobileDevice) {
                        playing = false;
                        videoMethod('pauseVideo');
                    }
                    else {
                        video.classList.add('keep-playing');
                        if (isMobileDevice) {
                            playing = false;
                            video.pause();
                            video.classList.remove('keep-playing');
                            video.parentElement.classList.remove('playing');
                            videoToggle.setAttribute("aria-label", "play video");
                            videoToggle.classList.remove('active');
                        }
                    }
                    video.addEventListener('click', function(e){
                        e.preventDefault();
                        videoToggle.click();
                    });
                }
            }
        });
    }
})();